import { render, staticRenderFns } from "./ToastsLinks.vue?vue&type=template&id=587374b0"
import script from "./ToastsLinks.vue?vue&type=script&lang=js"
export * from "./ToastsLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports